import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import px2vw from '../../utils/px2vw';

// const media = {
//     xs: (styles) => `
//         @media only screen and (max-width: 480px) {
//             ${styles}
//         }
//     `
// }

export const NavBar = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 60px;
    z-index: 500;
    position: fixed;

    @media screen and (max-width: 425px) {
        height: 30px;
    }
`;
export const Nav = styled.nav`
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5); 
    mix-blend-mode: normal;
    backdrop-filter: blur(24.4645px);
    height: 100px;
    padding-left: ${px2vw(200)};
    
    @media screen and (max-width: 1440px) {
    }

    @media screen and (max-width: 1024px) {
        font-size: 24px;
    }
     
    @media screen and (max-width: 768px) {
        font-size: 24px;
    }

    @media screen and (max-width: 425px) {
        font-size: 24px;
        height: 60px;
        padding-left: ${px2vw(35)};
    }

    @media screen and (max-width: 320px) {
        font-size: 20px;
    } 
`;

export const NavLink = css`
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 1rem; 
    height: 100%;
    cursor: pointer;
    text-decoration: none;

    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0A2540;
`;

export const Logo = styled(Link)`
    color: #fff;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
    align-items: center; 
    justify-content: center;

    font-family: ${props => props.logoFontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0A2540;
    font-weight: 900;
    line-height: 24px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #E32C5E;
    p {
        padding-top: 3px;
    }
    
    transition: 0.3s;
    &:hover {
        transform: scale(1.10);
    }

    @media only screen and (max-width: 425px) {
        font-size: 10px;
    }
`;

export const MenuBars = styled.i``;
export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end; 
    width: 100%;
    padding-right: ${px2vw(200)};
    margin-right: ${px2vw(200)};

    @media screen and (max-width: 425px) {
        font-size: 24px;
        padding-right: ${px2vw(35)};
        margin-right: ${px2vw(35)};
    }

    @media screen and (max-width: 320px) {
    }
`;

export const NavMenuLinks = styled(Link)`
    ${NavLink}
    flex-direction: column;
    justify-content: space-around;
    align-items: space-between;
    
    @media only screen and (max-width: 425px) {
        font-size: 10px;
        display: none;
    }

    @media only screen and (max-width: 768px) {
        padding: 8px;
    }
`;
export const NavMenuTitle = styled(motion.div)`
    transition: 0.3s;
    &:hover {
        transform: translateY(-5px); 
    }
`;

export const NavSelector = styled(motion.div)`
    width: 5px; 
    border-radius: 100% 100% 0px 0px;
    height: 0; 
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 25px solid white;
    z-index: 200;
    bottom: 0;
    position: absolute;
`

export const SvgBox = styled(motion.div)`
    visibility: hidden;
    cursor: pointer;
    @media only screen and (max-width: 425px) {
        font-size: 10px;
        visibility: visible;
    }
`;



export const NavDetailTitle = styled(motion.p)`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #0A2540;
`
export const NavDetailitem = styled(motion.p)`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #0A2540;
    cursor: pointer;
`

export const NavItemDetail = styled(motion.div)`
    display: flex;
    padding-top: 20px;
    margin-top: 10px;
`

export const NavIcon = styled(motion.div)`
    margin-top: 20px;
`